var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1978_22398",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1978_22398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_2",
    d: "M19.5422 20.5769L13.2615 14.2961C12.7615 14.7089 12.1865 15.032 11.5365 15.2654C10.8865 15.4987 10.214 15.6154 9.51916 15.6154C7.80999 15.6154 6.36348 15.0236 5.17961 13.84C3.99574 12.6564 3.40381 11.2103 3.40381 9.50157C3.40381 7.79284 3.99559 6.34617 5.17916 5.16155C6.36273 3.97695 7.80888 3.38465 9.51761 3.38465C11.2263 3.38465 12.673 3.97658 13.8576 5.16045C15.0422 6.34432 15.6345 7.79083 15.6345 9.5C15.6345 10.2141 15.5147 10.8962 15.2749 11.5462C15.0352 12.1961 14.7153 12.7615 14.3153 13.2423L20.5961 19.5231L19.5422 20.5769ZM9.51916 14.1154C10.8076 14.1154 11.899 13.6683 12.7932 12.7741C13.6874 11.8798 14.1346 10.7885 14.1346 9.5C14.1346 8.21153 13.6874 7.12018 12.7932 6.22595C11.899 5.33172 10.8076 4.8846 9.51916 4.8846C8.23069 4.8846 7.13934 5.33172 6.24511 6.22595C5.35089 7.12018 4.90378 8.21153 4.90378 9.5C4.90378 10.7885 5.35089 11.8798 6.24511 12.7741C7.13934 13.6683 8.23069 14.1154 9.51916 14.1154Z",
    fill: "#6D6D70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.83496910376cb3c106db1929f02ed183.svg";
export { ForwardRef as ReactComponent };